const INITIAL = {}

export default function cancellationReasonsInfo(state = INITIAL, action) {
  switch (action.type) {
    case "SET_DISCARDS_DATA":
      return (
        {
          action: "EDIT",
          data: action.data
        }
      )
    case "CREATE_DISCARDS_DATA":
      return (
        {
          action: "CREATE",
          data: {}
        }
      )
    default:
      return state;
  }
}